<template>
  <div class="page">
    <Header>
      <template #title>
        <span>リトル・ママオンラインフェスタ</span>
        抽選会プレゼント一覧
      </template>
    </Header>
    <div class="presents-wrapper">
      <div class="inner">
        <Heading>
          <template #heading>
            豪華キーワード3つで当たる<br>
            豪華商品がこちら
          </template>
        </Heading>
        <div class="presents">
          <Present
            v-for="(present, index) in presents" :key="index"
            :present="present"
          />
        </div>
      </div>
    </div>
    <div class="inner">
      <Howto />
    </div>
    <Floating>
      <template #content>
        <div v-if="month === '202006'">
          <Button06 :month="month"/>
        </div>
        <div v-if="month === '202007'">
          <Button07 :month="month"/>
        </div>
        <div v-if="month === '202008'">
          <Button08 :month="month"/>
        </div>
      </template>
    </Floating>
  </div>
</template>

<script>
import Header from '@/components/organisms/202006/Header.vue'
import Heading from '@/components/atoms/Heading.vue'
import Present from '@/components/molecules/Present.vue'
import Howto from '@/components/organisms/Howto.vue'
import Floating from '@/components/molecules/Floating.vue'
import Button06 from '@/components/atoms/202006/Button.vue'
import Button07 from '@/components/atoms/202007/Button.vue'
import Button08 from '@/components/atoms/202008/Button.vue'

export default {
  name: 'present',
  components: {
    Header,
    Heading,
    Present,
    Howto,
    Floating,
    Button06,
    Button07,
    Button08
  },
  data: () => ({
    presents: [
      {
        thumbnail: '/img/present/01.png',
        name: 'バルミューダ ザ・レンジ',
        num: '1名',
        description: 'キッチンを楽しくするオーブンレンジ。必要な機能を無駄のないデザインにまとめた、ちょうど良い大きさのオーブンレンジです。電子レンジの温めも、本格的なオーブン料理も、ダイヤル操作で迷わず使えるシンプルな設計。運転時の楽器の音色と共に、キッチンに楽しさをお届けします。',
        company: 'バルミューダ株式会社',
        url: 'https://www.balmuda.com/jp/range/'
      },
      {
        thumbnail: '/img/present/02.png',
        name: 'dyson V7',
        num: '1名',
        description: 'コード付き掃除機よりも確実にゴミを吸い取ります。コードのいらない解放感。最長30分の運転時間。安定したパワー供給で変わらない吸引力が続きます。ツールを切り替えて、高い場所もお掃除できます。さまざまな床だけでなく、高い場所や家具の下、床の隙間も、自在に掃除できます。',
        company: 'ダイソン株式会社',
        url: 'https://www.dyson.co.jp/'
      },
      {
        thumbnail: '/img/present/03.png',
        name: 'バッラリーニ フェラーラ フライパン深型',
        num: '1名',
        description: '御影石を彷彿とさせる美しいコーティングのフェラーラシリーズ。耐摩耗性に優れた5層のコーティングにより金属ヘラの使用可能。料理をよりおいしく仕上げるだけでなく、無駄な加熱や空焚きを防ぎ、ガス代の削減をサポート。',
        company: 'ツヴィリング J.A. ヘンケルスジャパン 株式会社',
        url: 'https://jp.zwilling-shop.com/'
      },
      {
        thumbnail: '/img/present/04.png',
        name: 'ツインフィン2 マルチパーパスナイフ',
        num: '1名',
        description: '新鋼材「N 60ステンレススチール」に素材により、刃こぼれしにくく、またサビにくいのが長所です。ミニマリズムをテーマに直線美を追求しており。スタイリッシュでかっこいい高性能の包丁を実現しています。',
        company: 'ツヴィリング J.A. ヘンケルスジャパン 株式会社',
        url: 'https://jp.zwilling-shop.com/'
      },
      {
        thumbnail: '/img/present/05.png',
        name: 'オリジナル絵本「たくさんのはじめて」',
        num: '10名',
        description: '毎日起こる「たくさんのはじめて」を暖かく見守り、思わずほほえんでしまう、そんなお話です。<br>お名前や出生情報がカスタマイズでき、記念品としても好評いただいています。大切なお子様が、絵本の主人公となって登場する、世界でたった一つのオリジナル絵本をお届けします。',
        company: 'cooing（運営会社：株式会社フォーチュン）',
        url: 'https://shop.cooing.gift/'
      },
      {
        thumbnail: '/img/present/06.png',
        name: 'manma 四季の離乳食セット',
        num: '1名',
        description: '「manma 四季の離乳食」は、旬の新鮮なお野菜を使用した離乳食です。 余分な調味料は使用せず、お野菜本来の味を活かした調理をしています。 離乳初期〜完了期のお子様それぞれの離乳段階に合わせたラインナップで、少しずつ素材そのものの食感や味に触れ、大人の食に近づいていけるようサポートします。アレルギー特定原材料7品目や食品添加物は使用しておりません。',
        company: '株式会社はたけのみかた',
        url: 'https://hatake-no-mikata.co.jp/'
      },
      {
        thumbnail: '/img/present/07.png',
        name: 'おやつなおやさい slow muffin',
        num: '4名',
        description: '我が子には、おやつでも栄養がきちんと摂れる安心安全なものを食べさせたい。<br>そんなことを日々思いながらも、仕事に家事に忙しくおやつ作りができないママたちの力になること。 そのために開発したのが SLOW MUFFIN です。',
        company: '株式会社下堂園',
        url: 'https://slowmuffin.jp/'
      }
    ]
  }),
  mounted () {
    document.title = '抽選会プレゼント一覧 - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0 100px
.presents-wrapper
  background-color: $lightpink
  padding: 25px 0
  .presents
    .present
      margin-top: 25px
</style>
